(function initializeCartConsent(globalScope) {
  'use strict';

  const syncConsentState = (checkbox, checkoutButton, errorMessage) => {
    const consentGranted = checkbox.checked;
    checkoutButton.disabled = !consentGranted;
    checkoutButton.setAttribute('aria-disabled', String(!consentGranted));

    if (consentGranted) {
      checkbox.removeAttribute('aria-invalid');
      errorMessage.hidden = true;
    }

    return consentGranted;
  };

  const bindCartConsent = (root) => {
    if (root.dataset.agetaCartConsentBound === 'true') return;

    const checkbox = root.querySelector('[data-cart-consent-checkbox]');
    const form = root.closest('form');
    const checkoutButton = form?.querySelector('[data-cart-checkout]');
    const errorMessage = root.querySelector('.cart-summary__consent-error');
    if (!checkbox || !form || !checkoutButton || !errorMessage) return;

    const showError = () => {
      checkbox.setAttribute('aria-invalid', 'true');
      errorMessage.hidden = false;
    };

    checkbox.addEventListener('change', () => {
      syncConsentState(checkbox, checkoutButton, errorMessage);
    });
    checkbox.addEventListener('invalid', showError);
    form.addEventListener('submit', (event) => {
      if (event.submitter !== checkoutButton || checkbox.checked) return;
      event.preventDefault();
      showError();
      checkbox.focus({ preventScroll: true });
    });

    root.dataset.agetaCartConsentBound = 'true';
    syncConsentState(checkbox, checkoutButton, errorMessage);
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-cart-consent]').forEach(bindCartConsent);
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { syncConsentState };
  }

  if (typeof globalScope.document !== 'undefined') {
    if (globalScope.document.readyState === 'loading') {
      globalScope.document.addEventListener('DOMContentLoaded', () => init(globalScope.document));
    } else {
      init(globalScope.document);
    }
    globalScope.document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
}(typeof window === 'undefined' ? globalThis : window));
